import { brandedUuid } from '../FlavorSchema.js';
export const TimesheetEntryIdSchema = brandedUuid('Invalid timesheet entry ID format');
export const TimesheetCapacityIdSchema = brandedUuid('Invalid timesheet capacity ID format');
export const TimesheetCapacityOverrideIdSchema = brandedUuid('Invalid timesheet capacity override ID format');
//# sourceMappingURL=TimesheetSchemas.js.map